import { Box, Button, Flex, Text, VStack } from '@chakra-ui/react';
import { FC } from 'react';

export interface PatientPostCallV2Props {
  /**
   * Callback function to redirect patient to their appointments in the patient app.
   */
  redirectToPatientApp: () => void;
  /**
   * Callback function to rejoin the call. If omitted, the button will not be displayed.
   */
  rejoinCall?: () => void;
}

/**
 * Post-call screen for patients using CallV2 design system.
 * Displays a friendly goodbye message and a button to return to their appointments.
 */
export const PatientPostCallV2: FC<PatientPostCallV2Props> = ({
  redirectToPatientApp,
  rejoinCall,
}) => {
  return (
    <Flex
      width="100vw"
      height="100vh"
      bg="bg.default"
      alignItems="center"
      justifyContent="center"
      data-testid="patient-post-call-v2"
    >
      <VStack spacing={6} textAlign="center">
        <Text fontSize="60px" lineHeight={1}>
          👋
        </Text>
        <Box>
          <Text fontSize="25px" fontWeight="bold" color="text.default" mb={2}>
            The session has ended
          </Text>
          <Text fontSize="md" color="text.light">
            Have a nice day!
          </Text>
        </Box>
        <Button
          size="lg"
          colorScheme="green"
          onClick={redirectToPatientApp}
          mt={4}
          data-testid="see-appointments-button"
        >
          See My Appointments
        </Button>
        {rejoinCall && (
          <Button
            variant="link"
            colorScheme="green"
            size="sm"
            onClick={rejoinCall}
            data-testid="rejoin-call-button"
          >
            Rejoin Call
          </Button>
        )}
      </VStack>
    </Flex>
  );
};
